import React, { useState }from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { resetPagination } from 'reducers/paginationSentEmailsSlice';
import { setFilters, resetFilters } from 'reducers/filtersSentEmailsSlice'; 
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedIcon from '@mui/icons-material/Feed';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom'; 
import { ToastContainer } from 'react-toastify'; 
import { TodayIs} from 'components/utils/TodayIs';
import ImportScript from 'components/utils/ImportScript';
import Footer from "pages/main/Footer";
import Alerts from 'pages/alerts/Alerts';
import Person from 'pages/main/Person';
import Messages from 'pages/messages/Messages';
import SentEmailList from 'pages/sentemails/SentEmailList';
 
const HomeSentEmail = () => {
    const {t,i18n} = useTranslation(['listDataGeneralSettings']); 
    const dispatch = useDispatch();
    const filtersSentEmailsDetails = useSelector((state) => state.filtersSentEmails); // Obtener filtros desde Redux
    const state = useSelector((state) => state);
    const enabled = state.loginUser.enabled;
    const roles = state.loginUser.roles;
    const defaultStore = state.loginUser.defaultStore;
    const [showModalSentEmails, setShowModalSentEmails] = useState(true); 

    const scriptUrl = '/js/sb-admin-2.min.js'; 

    const changeSelectedLanguage = () => {
        if (i18n.language === "es") {
            i18n.changeLanguage("en");
            dispatch(setFilters({ reasonFromES: "", reasonToES: "",statusFromES: "", statusToES: "" }));
        } else {
            i18n.changeLanguage("es");
            dispatch(setFilters({ reasonFromEN: "", reasonToEN: "",statusFromEN: "", statusToEN: "" }));
        }
    };

    const closeModalSentEmails = () => {    
        dispatch(resetPagination());
        dispatch(resetFilters());
        setShowModalSentEmails(false);
        return () => {};
    }; 

    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer/>
        {enabled===false ? <Navigate to="/"></Navigate>:
        <div id="page-top">
           
            {/* Page Wrapper */}
            <div id="wrapper">

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary toggled sidebar sidebar-dark accordion" id="accordionSidebar">

                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION FILTROS APLICADOS */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/sentemails">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className={filtersSentEmailsDetails.idFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Code_From')}
                    </div>
                    <li className={filtersSentEmailsDetails.idFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentEmailsDetails.idFrom==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.idFrom}
                    </li>
                    <div className={filtersSentEmailsDetails.idTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('PlaceHolder_Filter_Code_to')}
                    </div>
                    <li className={filtersSentEmailsDetails.idTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentEmailsDetails.idTo==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.idTo}
                    </li>
                    
                    {roles[0].listmenus.find((key)=>(key.name==="View_EMAILS_ALL_STORES"))&&
                        <>
                            <div className={filtersSentEmailsDetails.defaultStoreIdFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_From')}
                            </div>
                            <li className={filtersSentEmailsDetails.defaultStoreIdFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersSentEmailsDetails.defaultStoreIdFrom==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.defaultStoreIdFrom}
                            </li>
                            <div className={filtersSentEmailsDetails.defaultStoreIdTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                                {t('Text_Filter_Stores_To')}
                            </div>
                            <li className={filtersSentEmailsDetails.defaultStoreIdTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                                { filtersSentEmailsDetails.defaultStoreIdTo==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.defaultStoreIdTo}
                            </li>
                        </>
                    }
                    
 
                    <div className={filtersSentEmailsDetails.dateEmailFrom===null || filtersSentEmailsDetails.dateEmailFrom===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Date_From')}
                    </div>
                    <li className={filtersSentEmailsDetails.dateEmailFrom===null || filtersSentEmailsDetails.dateEmailFrom===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        {filtersSentEmailsDetails.dateEmailFrom===null || filtersSentEmailsDetails.dateEmailFrom===''? t('Text_Filter_Not_Apply'): new Date(filtersSentEmailsDetails.dateEmailFrom).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
                    <div className={filtersSentEmailsDetails.dateEmailTo===null || filtersSentEmailsDetails.dateEmailTo===''?"sidebar-heading":"sidebar-heading text-white"}>   
                        {t('Text_Filter_Date_To')}
                    </div>
                    <li className={filtersSentEmailsDetails.dateEmailTo===null || filtersSentEmailsDetails.dateEmailTo===''?"sidebar-heading text-warning":"sidebar-heading text-warning"}>
                        { filtersSentEmailsDetails.dateEmailTo===null || filtersSentEmailsDetails.dateEmailTo===''? t('Text_Filter_Not_Apply'):new Date(filtersSentEmailsDetails.dateEmailTo).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US')}
                    </li>
 
                    <div className={(filtersSentEmailsDetails.statusFromEN==='' && filtersSentEmailsDetails.statusFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Status_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSentEmailsDetails.statusFromEN==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.statusFromEN:filtersSentEmailsDetails.statusFromES==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.statusFromES}
                    </li>
                    <div className={(filtersSentEmailsDetails.statusToEN==='' && filtersSentEmailsDetails.statusToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Status_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSentEmailsDetails.statusToEN==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.statusToEN:filtersSentEmailsDetails.statusToES==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.statusToES}
                    </li>    

                    <div className={(filtersSentEmailsDetails.reasonFromEN==='' && filtersSentEmailsDetails.reasonFromES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Reason_From')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSentEmailsDetails.reasonFromEN==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.reasonFromEN:filtersSentEmailsDetails.reasonFromES==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.reasonFromES}
                    </li>
                    <div className={(filtersSentEmailsDetails.reasonToEN==='' && filtersSentEmailsDetails.reasonToES==='')?"sidebar-heading":"sidebar-heading text-white"}>
                        {t('Text_Filter_Reason_To')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { i18n.language==="en"?filtersSentEmailsDetails.reasonToEN==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.reasonToEN:filtersSentEmailsDetails.reasonToES==='' ? t('Text_Filter_Not_Apply'): filtersSentEmailsDetails.reasonToES}
                    </li>    
                    
                    <li className="sidebar-heading text-warning">
                    &nbsp;
                    </li>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings"))&&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/sentemails" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span>{t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                   <Link className="collapse-item" to="/sentemails" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                   
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/home" onClick={closeModalSentEmails} >
                            <LogoutIcon/>
                            <span>{t('Button_Back')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>

          
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        <ul className="navbar-nav ml-auto">
                             <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok">
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>   
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - Alerts */}
                            <Alerts/>
                            {/* Nav Item - Messages */}
                            <Messages/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1">
                                <br/>
                                <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                    <TodayIs/>  
                                </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}

                {/* Show Modals */}  
                <SentEmailList  
                    showModalSentEmails={showModalSentEmails}
                    setShowModalSentEmails={setShowModalSentEmails}
                />
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         
      </div>}
      {/* End of Body */}

    </>
  )
};

export default HomeSentEmail;
